<template>
    <!-- TODO 200% c'est sale -->
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="handshake" class="m-2"></b-icon>
                Information sur les calculs
            </p>
        </header>
        <section class="modal-card-body">

            <h1 class="title">Abréviations</h1>
            <ul>
                <li>FP = Frais de personnel</li>
                <li>FM = Frais de mission</li>
                <li>CM = Coût Matériel</li>
                <li>ST = Sous-traitants</li>
                <li>FG = Frais généraux</li>
            </ul>
            <br>

            <h1 class="title">Cas général</h1>
            <p>Coût du projet avant l'ajout des financeurs, à ce stade, il n'est pas possible de connaitre le montant des frais généraux.</p>
            <br>
            <span class="border" v-html="f1()"></span>
            <br>
            <br>
            <p>Pour ajouter un financeur, il faut connaitre le montant de sa participation ou le % de financement, ainsi que le % de frais généraux qu'il peut prendre en charge.</p>
            <br>

            <h1 class="title">Pour une participation variable basée sur un % de participation</h1>
            <p>La participation comprend également une part des frais généraux qui est calculable : </p>
            <br>
            <span class="border" v-html="f3()"></span>
            <br>
            <br>
            <p>Cette part de frais généraux est alors ajouté au coût du projet.</p>
            <p>Le calcul de la participation totale du financeur est la suivante :</p>
            <br>
            <span class="border" v-html="f4()"></span>
            <br>
            <br>
            <p>Et de fait :</p>
            <br>
            <span class="border" v-html="f5()"></span>
            <br>
            <br>

            <h1 class="title">Pour une participation à montant fixe</h1>
            <p>La participation à montant fixe comprend également une part des frais généraux.</p>
            <p>Cette part est calculable en deux étapes, la première étant de calculer le pourcentage de participation, puis la part de frais généraux.</p>
            <br>
            <span class="border" v-html="f2()"></span>
            <br>
            <br>
            <br>
            <span class="border" v-html="f2b()"></span>
            <br>
            <br>
            <p>Cette part de frais généraux est ajoutée au coût du projet.</p>
            <p>Le montant de participation reste donc fixe mais une part permet de participer aux frais généraux.</p>
            <br>

            <h1 class="title">Notes</h1>
            <p>
                Les taux de participation sont calculés <b style="color: red">sur le coût du projet sans frais généraux</b>, selon le montage financier du projet, le taux de participation total <b>peut donc légèrement varier par rapport au taux de participation affiché.</b>.
            </p>
            <br>
            <h1 class="title">Cas particulier sur CTMA</h1>
            <p>Les projets de type CTMA (case cochée dans le premier onglet) ont un traitement différent.</p>
            <p>En effet, les frais généraux sont calculés sur la base d'un plafond dépendant du nombre de jours de personnel non-support et des frais de mission.</p>
            <br>
            <span class="border" v-html="FG_CTMA()"></span>
            <br>
            <br>
            <p>Et la prise en charge financeur :</p>
            <br>
            <span class="border" v-html="formulaCTMA()"></span>

        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Fermer
            </button>
        </footer>
    </div>
</template>

<script>
import katex from "katex";

export default {
    name: "CalculInfoModal",
    props: {
    },
    computed: {

    },
    methods: {
        f1() {
            let html = katex.renderToString(
                "Coût\\ du\\ projet\\ sans\\ FG = FP + FM + CM + ST",
                {
                    throwOnError: false,
                });
            return html
        },
        f2() {
            let html = katex.renderToString(
                "\\%\\ de\\ participation = \\dfrac{Montant\\ de\\ la\\ participation}{\\%\\ de\\ FG\\ pris\\ en\\ charge \\times FP + Coût\\ du\\ projet\\ sans\\ FG}",
                {
                    throwOnError: false,
                });
            return html
        },
        f2b() {
            let html = katex.renderToString(
                "FG = \\%\\ de\\ participation \\times \\%\\ de\\ FG\\ pris\\ en\\ charge \\times FP",
                {
                    throwOnError: false,
                });
            return html
        },
        f3() {
            let html = katex.renderToString(
                "Part\\ de\\ FG = \\%\\ de\\ participation \\times \\%\\ de\\ FG\\ pris\\ en\\ charge \\times FP",
                {
                    throwOnError: false,
                });
            return html
        },
        f4() {
            let html = katex.renderToString(
                "Participation\\ totale = (\\%\\ de\\ participation \\times Coût\\ du\\ projet\\ sans\\ FG) + Part\\ de\\ FG",
                {
                    throwOnError: false,
                });
            return html
        },
        f5() {
            let html = katex.renderToString(
                "Participation\\ sans\\ frais\\ généraux = Participation\\ totale - Part\\ de\\ FG",
                {
                    throwOnError: false,
                });
            return html
        },
        FG_CTMA() {
            return katex.renderToString("FG=\\left(\\frac{Nb\\ jours\\ sans\\ support\\times12000}{210}\\right)-FM", {
                throwOnError: false,
            })
        },
        formulaCTMA() {
            let html = katex.renderToString(
                "\\text{Coût pris en charge}=\\text{Coût total}\\times\\text{\\% prise en charge}",
                {
                    throwOnError: false,
                });
            return html
        },
    }
};
</script>

<style scoped>

.modal-card-body {
    max-width: 100%;
    padding-left: 5%;
    padding-right: 5%;
}

.border {
    border: 1px solid black; /* Sets a 1px solid black border */
    padding: 18px; /* Adds some padding around the content */
}

</style>
